class IbeRequest {
  // Propiedad estática para almacenar la única instancia (Singleton)
  static instance = null

  // Constante con la URL base de la API
  static BASE_URL = '/admin'

  constructor() {
    if (IbeRequest.instance) {
      return IbeRequest.instance // Devuelve la instancia existente si ya fue creada
    }
    IbeRequest.instance = this // Crea la instancia única
  }

  // Método para manejar las respuestas y convertirlas a JSON
  async handleResponse(response) {
    switch (response.status) {
      case 200:
        return await response.json() // Éxito, devuelve la respuesta en JSON
      case 400:
        throw new Error('400: Bad Request. There was an issue with your request.')
      case 404:
        throw new Error('404: Not Found. The resource you requested could not be found.')
      default:
        throw new Error(`HTTP error! status: ${response.status}`) // Para otros códigos de estado
    }
  }

  // Método para construir la URL con parámetros dinámicos
  buildURL(endpoint, locale = 'en', params = {}) {
    let url = `/${locale}/${endpoint}` // Construye la URL base
    if (params && Object.values(params).length) {
      const queryString = new URLSearchParams(params).toString() // Convierte los parámetros a query string
      url = `${url}?${queryString}` // Añade los parámetros si existen
    }
    return url
  }

  // Método GET que acepta un endpoint y parámetros opcionales
  async get(endpoint) {
    try {
      const response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return await this.handleResponse(response) // Manejo de la respuesta
    } catch (error) {
      console.error('Error en GET:', error) // Captura errores y los muestra en consola
      throw error // Vuelve a lanzar el error para que el código que lo llama lo maneje
    }
  }

  // Método POST que acepta un endpoint, datos y parámetros opcionales
  async post(endpoint, data) {
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data), // Convierte los datos a JSON para enviarlos
      })
      return await this.handleResponse(response) // Manejo de la respuesta
    } catch (error) {
      console.error('Error en POST:', error)
      throw error
    }
  }

  // Método PUT que acepta un endpoint, datos y parámetros opcionales
  async put(endpoint, data) {
    try {
      const response = await fetch(endpoint, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
      return await this.handleResponse(response)
    } catch (error) {
      console.error('Error en PUT:', error)
      throw error
    }
  }

  // Método DELETE que acepta un endpoint y parámetros opcionales
  async delete(endpoint) {
    try {
      const response = await fetch(endpoint, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      return await this.handleResponse(response)
    } catch (error) {
      console.error('Error en DELETE:', error)
      throw error
    }
  }

  // Método estático para obtener la instancia única de la clase
  static getInstance() {
    if (!IbeRequest.instance) {
      IbeRequest.instance = new IbeRequest() // Crea la instancia si no existe
    }
    return IbeRequest.instance
  }
}

export const IbeEndpoints = {
  FLIGHTANDHOTELS: 'flight_and_hotel_tabs',
}

export const ibeRequest = IbeRequest.getInstance()
